import module from 'app/module.js'

const regexp = /INPUT|SELECT|TEXTAREA/i

module.directive('appContextmenuDisabled', ($document, $window) => {
  return {
    restrict: 'A',
    link () {
      $document[0].oncontextmenu = (event) => {
        const el = $window.event.srcElement || event.target
        const tp = (el.tagName || '').toUpperCase()

        if (!regexp.test(tp)) return false
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/app/directives/app-contextmenu-disabled/directive.js